import { render } from "./AlarmEventsPage.vue?vue&type=template&id=1dac70c5"
import script from "./AlarmEventsPage.vue?vue&type=script&lang=js"
export * from "./AlarmEventsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\eguchi\\Desktop\\git\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__